module.exports = __webpack_public_path__ + "img/ship_position-w.svg";